import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        display: 'flex',
        flex: 1,
        margin: theme.spacing(),
        flexDirection: 'column',
    },
});

const Box = ({ classes, className, children }) => (
    <Paper className={classNames(classes.root, className)} elevation={1}>
        {children}
    </Paper>
);

Box.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default withStyles(styles)(Box);
